import { render } from "./DeviceReclaim.vue?vue&type=template&id=1433acad&scoped=true"
import script from "./DeviceReclaim.vue?vue&type=script&lang=js"
export * from "./DeviceReclaim.vue?vue&type=script&lang=js"

import "./DeviceReclaim.vue?vue&type=style&index=0&id=1433acad&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1433acad"]])

export default __exports__